import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthTokenService } from './auth-token.service';


@Injectable()
export class AuthGuard  {

  constructor(private router: Router, private authService: AuthTokenService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // if (localStorage.getItem('userToken')) {
    if (!this.authService.isTokenExpired()) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
